import { Button } from "@mui/material";

const Buttons = ({ btnHandler, children, disabled }) => (
  <Button variant="contained" color="primary" onClick={btnHandler} disabled={disabled}>
    {children}
  </Button>
);

export default Buttons;
